// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.naoAtendidoDialog.title': 'Encerrar como Não atendido',
    'shipments.naoAtendidoDialog.description':
      'A viagem {{number}} será encerrada sem conclusão. O conjunto volta para Disponível no Painel de Descarga e o monitoramento automático é encerrado. A linha e os dados são mantidos no histórico.',
    'shipments.naoAtendidoDialog.reasonLabel': 'Motivo do não atendimento',
    'shipments.naoAtendidoDialog.searchReason': 'Buscar motivo…',
    'shipments.naoAtendidoDialog.cobrancaLabel': 'Cobrança',
    'shipments.naoAtendidoDialog.cobrancaHint': 'Decidida caso a caso. Sim exige a observação explicando o que será cobrado.',
    'shipments.naoAtendidoDialog.noteLabel': 'Observação',
    'shipments.naoAtendidoDialog.notePlaceholderCobranca': 'O que será cobrado e por quê',
    'shipments.naoAtendidoDialog.noteRequired': 'Cobrança Sim exige a observação.',
    'shipments.naoAtendidoDialog.wait': 'Aguarde…',
    'shipments.naoAtendidoDialog.closeTrip': 'Encerrar',
  },
  en: {
    'shipments.naoAtendidoDialog.title': 'Close as Unattended',
    'shipments.naoAtendidoDialog.description':
      'Trip {{number}} will be closed without completion. The set returns to Available on the Unloading Panel and automatic monitoring ends. The row and its data are kept in the history.',
    'shipments.naoAtendidoDialog.reasonLabel': 'Unattended reason',
    'shipments.naoAtendidoDialog.searchReason': 'Search reason…',
    'shipments.naoAtendidoDialog.cobrancaLabel': 'Billing',
    'shipments.naoAtendidoDialog.cobrancaHint': 'Decided case by case. Yes requires a note explaining what will be billed.',
    'shipments.naoAtendidoDialog.noteLabel': 'Note',
    'shipments.naoAtendidoDialog.notePlaceholderCobranca': 'What will be billed and why',
    'shipments.naoAtendidoDialog.noteRequired': 'Billing Yes requires the note.',
    'shipments.naoAtendidoDialog.wait': 'Please wait…',
    'shipments.naoAtendidoDialog.closeTrip': 'Close',
  },
  es: {
    'shipments.naoAtendidoDialog.title': 'Cerrar como No atendido',
    'shipments.naoAtendidoDialog.description':
      'El viaje {{number}} se cerrará sin completarse. El conjunto vuelve a Disponible en el Panel de descarga y finaliza el monitoreo automático. La fila y sus datos se mantienen en el historial.',
    'shipments.naoAtendidoDialog.reasonLabel': 'Motivo del no atendimiento',
    'shipments.naoAtendidoDialog.searchReason': 'Buscar motivo…',
    'shipments.naoAtendidoDialog.cobrancaLabel': 'Cobro',
    'shipments.naoAtendidoDialog.cobrancaHint': 'Decidido caso a caso. Sí exige la observación explicando qué se cobrará.',
    'shipments.naoAtendidoDialog.noteLabel': 'Observación',
    'shipments.naoAtendidoDialog.notePlaceholderCobranca': 'Qué se cobrará y por qué',
    'shipments.naoAtendidoDialog.noteRequired': 'Cobro Sí exige la observación.',
    'shipments.naoAtendidoDialog.wait': 'Espere…',
    'shipments.naoAtendidoDialog.closeTrip': 'Cerrar',
  },
}
